import * as React from "react";
import Tooltip from "@mui/material/Tooltip";

export default function AppTooltip({
  title,
  children,
  placement = "top",
  arrow = true,
  enterDelay = 300,
  disableInteractive = false,
}) {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow={arrow}
      enterDelay={enterDelay}
      disableInteractive={disableInteractive}
    >
      {children}
    </Tooltip>
  );
}